interface BadgeProps {
  label: string;
  color?: string;
  title?: string;
}

export function Badge({ label, color, title }: BadgeProps) {
  return (
    <span className="badge" title={title}>
      {color && <span className="badge__dot" style={{ background: color }} />}
      {label}
    </span>
  );
}
